export default __webpack_public_path__ + "static/media/wasserkraft_oli.c43baa15.svg";